import { i18n } from 'core/i18n';
import React from 'react';
import { LoadingDots } from 'commonsComponents/loadingDots';
import { OKButton } from 'components/commons/OKButton/OKButton';
const { formatText } = i18n
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';

function DocumentsModalFooterPrimaryButton({
    isCurrentDocumentRead,
    areAlldocumentsAccepted,
    isSavingDocumentAcceptance,
    onConfirm,
    onContinue,
    onContinueDisabled,
    currentDocument,

}) {
    const getContent = () => {
        if (isSavingDocumentAcceptance) return <LoadingDots inline size="large" color="dark" />;
        if (areAlldocumentsAccepted) return formatText('contractsView-dic_buttonUnderstood');
        return formatText('contractsView-dic_buttonAcceptAndContinue');
    };

    const handleClickPrimaryButton = event => {
        if (__CONTACT_CENTER__ ? currentDocument.dmsDocumentType === "DIR" && currentDocument.radioButton && currentDocument.isRead : currentDocument.dmsDocumentType === "DIR" && currentDocument.isRead) return onConfirm(event);
        if (__CONTACT_CENTER__ ? currentDocument.dmsDocumentType === "INE" && currentDocument.radioButton && currentDocument.isRead : currentDocument.dmsDocumentType === "INE" && currentDocument.isRead) return onContinue(event);
    };

    let isDisabled = false;

    if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
        if (currentDocument.dmsDocumentType === "INE" && currentDocument.radioButton && currentDocument.isRead) {
            isDisabled = false;
        } else {

            if (currentDocument.radioButton && currentDocument.isRead) {
                isDisabled = false;

            } else {
                isDisabled = true;

            }
        }
    } else {
        if (isCurrentDocumentRead) {
            isDisabled = isSavingDocumentAcceptance;
        } else if (!isCurrentDocumentRead && !areAlldocumentsAccepted) {
            isDisabled = true;
        }
    }

    let handleClick;
    if (isCurrentDocumentRead || areAlldocumentsAccepted) {
        handleClick = handleClickPrimaryButton;
    } else {
        handleClick = onContinueDisabled;
    };

    return (
        <OKButton onClick={handleClick} disabled={isDisabled}>
            {getContent()}
        </OKButton>
    );
}

export default DocumentsModalFooterPrimaryButton;